import api from './api';

export const getSpecifications = async () => {
  const { data } = await api.get('/specifications');
  return data;
};

export const getSpecification = async (id) => {
  const { data } = await api.get(`/specifications/${id}`);
  return data;
};

export const createSpecification = async (spec) => {
  const { data } = await api.post('/specifications', spec);
  return data;
};

export const updateSpecification = async (id, spec) => {
  const { data } = await api.put(`/specifications/${id}`, spec);
  return data;
};

export const deleteSpecification = async (id) => {
  const { data } = await api.delete(`/specifications/${id}`);
  return data;
};

export const updateSpecProducts = async (id, productIds) => {
  const { data } = await api.put(`/specifications/${id}/products`, { product_ids: productIds });
  return data;
};
